import { FlightDeckClient } from '@atlassiansox/flight-deck-frontend-client';

import { PRODUCT_IDENTIFIER } from '@townsquare/config/constants';

import {
	ProductConfigurationApiLink,
	ProductConfigurationApiProduct,
	ProductConfigurationResponse,
	FlightDeckArtifactLink,
	FlightDeckArtifactProduct,
	FlightDeckProductConfigurationArtifact,
} from './types';

const transformFlightDeckArtifactProductsToProductConfigurationProduct = (
	artifactProduct: FlightDeckArtifactProduct,
): ProductConfigurationApiProduct => {
	return {
		key: artifactProduct.apsKey,
		href: artifactProduct.siteUrlSuffix || '',
		label: artifactProduct.displayName,
		rebrandedLabel: artifactProduct.rebrandedDisplayName,
		description: artifactProduct.subtitle || null,
		ordinal: artifactProduct.ordinal,
	};
};

const transformFlightDeckArtifactLinkToProductConfigurationLink = (
	artifactLink: FlightDeckArtifactLink,
): ProductConfigurationApiLink => {
	return {
		key: artifactLink.apsKey,
		href: artifactLink.url,
		label: artifactLink.displayName,
		description: artifactLink.subtitle || null,
		iconUrl: artifactLink.iconUrl,
		ordinal: artifactLink.ordinal,
	};
};

// TODO: remove flightDeckAssetsBaseUrl once Assets becomes it's own app
export const transformFlightDeckArtifactToProductConfiguration = (
	artifact: FlightDeckProductConfigurationArtifact,
): ProductConfigurationResponse => ({
	products: artifact.products.reduce<Record<string, ProductConfigurationApiProduct>>((acc, val) => {
		acc[val.apsKey] = transformFlightDeckArtifactProductsToProductConfigurationProduct(val);
		return acc;
	}, {}),
	links: artifact.links.reduce<Record<string, ProductConfigurationApiLink>>((acc, val) => {
		acc[val.apsKey] = transformFlightDeckArtifactLinkToProductConfigurationLink(val);
		return acc;
	}, {}),
	flightDeckAssetsBaseUrl: artifact.flightDeckAssetsBaseUrl,
});

export const resolvedFlightDeckClient = new FlightDeckClient(PRODUCT_IDENTIFIER);
